import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    requiredSymbol: {
        paddingLeft: theme.spacer / 2,
        color: '#ff0000'
    }
}));

export default useStyles;